<template>
  <van-popup v-model="show" round position="bottom" @close="handleChange">
    <van-picker show-toolbar title="选择手机品牌" :columns="brands" @cancel="show = false" value-key="BrandName" @confirm="select" />
    <!--<div class="title">选择手机品牌</div>-->
    <!--<div class="brands">-->
      <!--<div :class="['brand', 'one-line', {'selected': currIndex===index}]" v-for='(item,index) in brands' :key='index' @click='select(index)'>{{item.BrandName}}</div>-->
    <!--</div>-->
  </van-popup>
</template>

<script>
  import Vue from 'vue';
  import { Popup,Picker } from 'vant';
  import { httpOpen } from "../scripts/network";

  Vue.use(Popup);
  Vue.use(Picker);
  export default {
    data() {
      return {
        currIndex: -1,
        show: this.shows,
        image: null,
        input: null,
        showWarning: false,
        brands: []
      }
    },
    watch: {
      value(val) {
        if (val) {
          let brands = window.session.get('brands');
          if (brands && Object.keys(brands) !== 0) {
            this.brands = brands;
            this.show = val;
          } else {
            setTimeout(async () => {
              this.brands = await this.getBrands();
              this.show = val;
            }, 0)
          }
        } else {
          this.show = val;
        }
      }
    },
    props: {
      value: {
        default: false,
        type: Boolean
      },

    },
    methods: {
      async getBrands() {
        this.$loading.show()
        const params = {
            type: 'post'
          };
          this.cancelGetBrands && this.cancelGetBrands();
          let ret;
          try {
            ret = await httpOpen("/Common/GetBrand", params, cancel => {
              this.cancelGetBrands = cancel;
            });
          } catch (error) {
            this.$loading.hide()
          }
          this.$loading.hide()
          window.session.save('brands', ret.Data);
          return ret.Data;
      },
      select(value,index) {
        this.currIndex=index;
        this.$emit('select', { brand: value});
      },
      handleChange(value) {
        this.$emit('callback', { dialog: value });
      },
    },

  }
</script>

<style scoped>
  .van-popup {
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    padding-top: 16px;
  }
  .van-popup>>>.van-picker__confirm{
    color: #C28954;
  }
  .van-popup>>>.van-picker-column__item--selected{
    font-weight: 600;
  }
</style>